import { City, State, County, ProjectType } from '@app/core/models';

export class GasAvailabilityLetterModel {
  id: number;
  // service Information
  projectName: string;
  landDistrict: string;
  projectAddress: string;
  landLot: string;
  cityId: number;
  serviceCity: City;
  stateId: string;
  serviceState: State;
  countyId: string;
  serviceCounty: County;
  zip: string;
  // Applicant Information
  projectTypeId: string;
  applicantProjectType: ProjectType;
  closestStreet: string;
  letterAddressedTo: string;
  companyName: string;
  mailingAddress: string;
  mailingCityId: number;
  applicantCity: City;
  mailingStateId: string;
  applicantState: State;
  applicantZip: string;
  contactName: string;
  contactPhoneNumber: string;
  applicantPhoneNumberExtension: string;
  applicanteMailAddress: string;
  fax: string;
  specialNotes: string;
  recordCreateDate: Date;
  recordCreateUserId: string;
  recordUpdateDate: Date;
  recordUpdateUserId: string;
  disable = true;
}

export class GetLettersModel {
    id: string;
    Address: string;
    Status: string;
}


